import * as R from 'ramda';

const takeMap = R.useWith(R.pipe, [R.take, R.map]);

export default takeMap;
